function addSubField( endpointId, field, currentItem, group, parentGroup ) {
	return {
		type: 'ENDPOINT_ADD_SUB_FIELD',
		payLoad: {
			endpointId,
			field,
			currentItem,
			group,
			parentGroup
		}
	}
}

function removeSubField( endpointId, index, group, currentItem, action ) {
	return {
		type: 'ENDPOINT_REMOVE_SUB_FIELD',
		payLoad: {
			endpointId,
			index,
			group,
			currentItem,
			action
		}
	}
}

function changeSubField(endpointId, group, groupId, fieldIndex, value, currentItem, action, inputType, id) {
	return {
		type: 'ENDPOINT_CHANGE_SUB_FIELD',
		payLoad: {
			endpointId,
			group,
			groupId,
			fieldIndex,
			value,
			currentItem,
			action,
			inputType,
			id
		}
	}
}

export { addSubField, removeSubField, changeSubField };
